const getHooks = (useFrameHooks) => {
    const useFeatureSwitches = () => {
        const { useFrameContext } = useFrameHooks();
        const { featureSwitches, loading } = useFrameContext();
        return { featureSwitches, loading };
    };
    return {
        useFeatureSwitches,
    };
};
export const featureSwitchesModule = {
    name: 'featureSwitchesModule',
    getHooks,
};
//# sourceMappingURL=feature-switches.js.map